import React, { useState, useEffect, useRef } from 'react';
import video from '../images/trippy.mov';

const resume = "https://drive.google.com/drive/folders/1lhR9vXQ-mCEwSA9dOcNsaaSkYyxO8-MV?usp=sharing";

const FloatingMenu = () => {
  const [selectedItem, setSelectedItem] = useState('Home');
  const [contactItem, setContactItem] = useState('Contact');  
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);

  const handleResumeClick = () => {
    window.open(resume, '_blank');
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 0) {
        setIsNavbarVisible(false);
      } else {
        setIsNavbarVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleAboutHover = (isHovering) => {
    setVideoPlaying(isHovering);
  };

  return (
    <div className={`fixed top-7 left-0 right-0 flex justify-center items-center transition-opacity duration-300 pointer-events-none ${isNavbarVisible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} style={{ zIndex: 20 }}>
      <nav className="bg-white bg-opacity-100 border-2 border-black rounded-full px-2 py-2 flex flex-row backdrop-blur-sm">
        <a
          href="/"
          onClick={() => setSelectedItem('Home')}
          className={`cursor-pointer flex-1 text-center py-2 px-4 md:px-6  ${selectedItem === 'Home'
          ? 'text-black rounded-full hover:bg-gray-500 hover:bg-opacity-30 cursor-pointer'
          : 'text-black-600 rounded-full hover:bg-gray-500 hover:bg-opacity-30 cursor-pointer'} transition duration-500`}
        >
          <h3 className="font-normal text-center text-2xl cursor-pointer">Home</h3>
        </a>
        <a
          href="/about"
          onClick={() => setSelectedItem('About')}
          onMouseEnter={() => handleAboutHover(true)}
          onMouseLeave={() => handleAboutHover(false)}
          className={`relative flex-1 text-center py-2 px-4 md:px-6 text-black rounded-full overflow-hidden ${selectedItem === 'About'
          ? 'text-black rounded-full hover:bg-gray-500 hover:bg-opacity-30 cursor-pointer'
          : 'text-black-600 rounded-full hover:bg-gray-500 hover:bg-opacity-30 cursor-pointer'} transition duration-500`}
          style={{ 
            position: 'relative', 
            zIndex: 1, 
            textDecoration: 'none',
            backgroundColor: 'transparent',
            overflow: 'hidden',
          }}
        >
          <h3 className="font-normal text-center text-2xl cursor-pointer">About</h3>
          <div className="cursor-pointer video-container">
            <video
              className="thevideo cursor-pointer absolute top-0 left-0 w-full h-full object-cover"
              autoPlay
              loop
              muted
              style={{
                opacity: videoPlaying ? 0.4 : 0, // Initial opacity set to 0 when not hovering
                transition: 'opacity 0.3s ease-in-out', // Smooth transition for opacity change
              }}
            >
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </a>
        <a
          href="/contact"
          onClick={() => setSelectedItem('Contact')}
          className={`cursor-pointer flex-1 text-center py-2 px-4 md:px-6 ${selectedItem === 'Contact'
            ? 'bg-gray-500 text-black rounded-full bg-opacity-20 cursor-pointer'
            : 'text-black-600 rounded-full hover:bg-gray-500 hover:bg-opacity-30 cursor-pointer'} transition duration-500`}
        >
          <h3 className="font-normal text-center text-2xl cursor-pointer">Contact</h3>
        </a>
      </nav>
    </div>
  );
};

export default FloatingMenu;
